const en = {
  nav: {
    home: 'Home',
    myNotes: 'My Notes',
    viewMode: 'VIEW MODE',
    editorView: 'Editor View',
    adaptedView: 'Adapted View',
    contentType: 'CONTENT TYPE',
    mindmaps: 'Mindmaps',
    flashcards: 'Flashcards',
    podcast: 'Podcast',
    studyNotes: 'Study notes',
    upgrade: 'Upgrade',
    upgradeMessage: 'Upgrade your plan to unlock the limits.',
    settings: 'Settings',
    connection: 'Connection',
    signOut: 'Sign out',
  },
  home: {
    welcome: 'Ready to learn ?',
    visualProfile: '🎨 You are a visual learner. Ready to transform your courses?',
    auditoryProfile: '🎧 You are an auditory learner. Turn your courses into podcasts.',
    readingProfile: '📖 You are a reading/writing learner. Organize your ideas.',
    kinestheticProfile: '🤲 You are a kinesthetic learner. Take action!',
    blankNote: 'Blank Note',
    startFromScratch: 'Start from scratch',
    tagline: 'You provide the effort, we handle the tools.',
    importFailed: 'Import failed',
    importInProgress: 'Import in progress',
    importPreparingMessage: 'We are preparing your {label}. This may take a few seconds.',
    close: 'Close',
    limitReachedMessage: 'You have reached the limit of 5 file imports on the free plan. Upgrade to a higher plan to continue.',
    fileTooLargeError: 'The file is too large or complex to process right now. Try a shorter document, or split it into smaller parts and try again.',
    importFailedPrefix: 'Import failed: ',
    unexpectedError: 'An unexpected error occurred.',
    unsupportedFormat: 'Unsupported file format.',
    sourceType: {
      audio: 'audio',
      pdf: 'file',
      image: 'image',
      doc: 'document',
      link: 'link',
      youtube: 'YouTube link',
    },
  },
  import: {
    audioTriggerTitle: 'Record / Import audio',
    audioTriggerDesc: 'Microphone and audio files',
    audioTitle: 'Audio',
    audioSubtitle: 'Record your voice or import audio files',
    startRecording: 'Start recording',
    startRecordingDesc: 'Capture your course in real time from the microphone',
    importAudioFiles: 'Import audio files',
    importAudioFormats: 'MP3, WAV, M4A, OGG, FLAC…',
    dragDropAudio: 'Drag and drop one or more audio files here',
    addAnotherAudio: 'Add another audio',
    reset: 'Reset',
    confirmImport: 'Confirm import ({count})',
    audioFileFallback: 'Audio file',
    recordingInProgress: 'Recording in progress',
    stopRecording: 'Stop',
    importFile: 'Import a file',
    importFileSubtitle: 'Choose documents from your computer',
    dragDropFiles: 'Drag and drop files here',
    addAnotherFile: 'Add another file',
    confirmFileImport: 'Confirm import ({count})',
    supportedFormats: 'PDF, Word, Images',
    videoLink: 'Video link',
    videoLinkSubtitle: 'Paste the URL of a YouTube video to analyze',
    videoPlaceholder: 'https://www.youtube.com/watch?v=...',
    importLink: 'Import a link',
    importLinkSubtitle: 'Website URL to extract content from',
    linkPlaceholder: 'https://...',
    analyze: 'Analyze',
    cancel: 'Cancel',
    record: 'Record',
    processing: 'Processing…',
    upload: 'Upload',
    videoLinkHint: 'Press Enter or click "Confirm" to submit',
    confirmLink: 'Confirm',
  },
  app: {
    loadingWorkspace: 'Loading your workspace…',
  },
  notes: {
    loadingTitle: 'Loading your note',
    loadingSubtitle: 'This may take from 1 to several minutes for long or complex content.',
    assistantTitle: 'Plynote assistant',
    openAssistant: 'Open Plynote assistant',
    closeAssistant: 'Close Plynote assistant',
    chatFullscreen: 'Fullscreen chat',
    chatExitFullscreen: 'Exit fullscreen chat',
    chatAnswering: 'AI is answering...',
    chatWelcomeGreeting: 'Hey, {name}',
    chatWelcomeMessage: 'You can ask me any question here.',
    askQuestion: 'Ask your question...',
    lastUpdate: 'Last update:',
    date: {
      today: 'Today - {time}',
      yesterday: 'Yesterday - {time}',
      unknown: 'Unknown date',
    },
    sort: {
      label: 'Sort:',
      mostRecent: 'Most recent',
      oldest: 'Oldest',
      oldestToNewest: 'Oldest to newest',
      newestToOldest: 'Newest to oldest',
    },
    sections: {
      today: 'Today',
      last30days: 'Last 30 Days',
      earlier: 'Earlier',
    },
    search: {
      placeholder: 'Search notes by name...',
    },
    loading: 'Loading notes...',
    singleNote: 'note',
    pluralNotes: 'notes',
    empty: {
      signIn: 'Sign in to view your notes.',
      noNotes: 'No notes found yet.',
      noMatch: 'No notes match your search.',
    },
    menu: {
      title: 'Note actions',
      newName: 'New name',
      ok: 'OK',
      actions: 'Actions',
      deleteConfirm: 'Are you sure you want to delete this note? This action is irreversible.',
    },
    untitled: 'Untitled note',
    adaptedView: {
      emptyTitle: 'Format not generated yet',
      emptyDescriptionWithContent: 'This format has not been generated yet for this note. Launch generation to display this view.',
      emptyDescriptionWithoutContent: 'No editor content detected. First add or load the source content, then launch generation.',
      noContentFallback: 'No editor content detected. First add or load the source content, then launch generation.',
      dismissErrorLabel: 'Dismiss error',
      generateButton: 'Generate current format',
      regenerateButton: 'Regenerate this content',
      deepMode: 'Deep',
      summarizedMode: 'Summarized',
    },
  },
  payment: {
    chooseSubscription: 'Choose a subscription',
    selectPlan: 'Select a plan to continue on Plynote.',
    mustBeSignedIn: 'You must be signed in to subscribe.',
    loadingPlans: 'Loading Stripe plans...',
    mostPopular: 'Most popular',
    save: 'Save {pct}%',
    perWeek: '/week',
    currentPlan: 'Current plan',
    redirecting: 'Redirecting...',
    monthly: 'Monthly',
    yearly: 'Yearly',
    featureUnlimitedFormats: 'Unlimited format adaptations',
    featureUnlimitedChat: 'Unlimited chat messages',
    featureUnlimitedUploads: 'Unlimited uploads',
    featureEmailSupport: 'Email support',
    chooseMonthly: 'Choose Monthly',
    chooseYearly: 'Choose Yearly',
    billedYearly: 'Billed yearly {amount}',
    billedMonthly: 'Billed monthly {amount}',
  },
  settings: {
    title: 'Settings',
    subtitle: 'Account settings, appearance, and session security.',
    redirectingToStripe: 'Redirecting to Stripe...',
    redirectingDesc: "You are about to be redirected to Stripe's secure payment page.",
    loading: 'Loading your settings...',
    loadingDesc: 'We are retrieving your account information and current subscription.',
    stripeRedirectFailed: 'Stripe redirect failed',
    retrySubscriptions: 'Retry from subscriptions',
    accountInfo: 'Account information',
    accountInfoDesc: 'Your main profile information.',
    username: 'Username',
    email: 'Email',
    notProvided: 'Not provided',
    currentPlan: 'Current Plan',
    currentPlanDesc: 'Review your active subscription, upgrade, or cancel.',
    loadingPlan: 'Loading your plan...',
    planLabel: 'Plan',
    statusLabel: 'Status',
    priceLabel: 'Price',
    activeSubscription: 'Active subscription',
    noSubscription: 'No subscription',
    upgrade: 'Upgrade',
    manageSubscription: 'Manage subscription',
    perMonth: '/month',
    perYear: '/year',
    theme: 'Theme',
    themeDesc: 'Choose the app appearance.',
    themeLight: 'Light',
    themeDark: 'Dark',
    themeSystem: 'System',
    language: 'Language',
    languageDesc: 'Choose the interface language.',
    languageEn: 'English',
    languageFr: 'Français',
    session: 'Session',
    sessionDesc: 'Sign out cleanly from your account.',
    signOut: 'Sign out',
  },
  auth: {
    loginSubtitle: 'Access your notes and personalized adaptations.',
    signupSubtitle: 'Join Plynote and start learning differently.',
    checkEmail: 'Check your email',
    verificationSent: 'A verification code has been sent to',
    verifying: 'Verifying...',
    verifyCode: 'Verify code',
    resendIn: 'Resend in {sec}s',
    resendCode: 'Resend code',
    back: 'Back',
    newPassword: 'New password',
    resetPassword: 'Reset password',
    signIn: 'Sign in',
    createAccount: 'Create an account',
    chooseNewPassword: 'Choose a new secure password for your account.',
    enterEmailForReset: 'Enter your email address to receive a reset link.',
    newPasswordPlaceholder: 'New password',
    confirmPasswordPlaceholder: 'Confirm password',
    updating: 'Updating...',
    changePassword: 'Change password',
    sending: 'Sending...',
    sendLink: 'Send link',
    linkSent: 'Link sent — check your inbox.',
    continueWithGoogle: 'Continue with Google',
    or: 'OR',
    signInTab: 'Sign in',
    signUpTab: 'Sign up',
    passwordPlaceholder: 'Password',
    signingIn: 'Sign in...',
    forgotPassword: 'Forgot password?',
    fullNamePlaceholder: 'Full name',
    usernamePlaceholder: 'Username',
    passwordMinPlaceholder: 'Password (min. 8 characters)',
    creating: 'Creating...',
    createMyAccount: 'Create my account',
  },
  landing: {
    navFeatures: 'Features',
    navHelp: 'Help',
    ctaStart: 'Start now',
    heroTitle: 'Start real learning',
    heroSubtitle: 'Turn anything into Mind maps. Flashcards. Podcasts. Study notes, and more. Everything you need — in one place.',
    startFree: 'Start free →',
    noCreditCard: 'No credit card required for the free plan.',
    featuresTitle: 'Everything you need to master all types of documents',
    featuresSubtitle: 'Designed for students, researchers, and knowledge workers who demand precision.',
    feature1Title: 'Extract equations',
    feature1Desc: 'Upload any PDF. Plynote extracts every equation automatically, preserving LaTeX and mathematical notation.',
    feature2Title: 'Chat with your documents',
    feature2Desc: 'Ask questions about notion or formulas, get instant answers, and explore complex concepts with your AI research assistant.',
    feature3Title: 'Adapt to your style',
    feature3Desc: 'Mindmaps, flashcards, podcasts, or smart sheets. Choose how you learn and retain information.',
    notJustTool1: 'Not just a note-taking tool.',
    notJustTool2: 'It is a real assistant.',
    notJustToolDesc: "It's a real research assistant that turns passive documents into active understanding — so you can finally focus on what matters: your research.",
    whyTitle: 'Why Plynote is better than the others',
    whySubtitle: 'Plynote compares to other leading research tools.',
    faqTitle: 'Frequently asked questions',
    faqSubtitle: 'Everything you need to know about Plynote.',
    faq1Q: 'What file formats does Plynote support ?',
    faq1A: 'Plynote supports PDF, DOCX, DOC, TXT, PNG, JPEG, audio files and audio recordings.',
    faq2Q: 'Does Plynote accurately extract math equations ?',
    faq2A: 'Yes. Plynote is specifically designed to recognize and extract mathematical, physics, chemistry, and statistical formulas — even from scanned PDFs or complex documents.',
    faq3Q: 'Are formulas preserved when generating mindmaps, smart text, audio, and flashcards ?',
    faq3A: "Yes. Plynote keeps every formula intact across all formats. The same equation you see in the editor appears exactly in your mindmap, smart text, audio summary, and flashcards. We use a powerful algorithm to ensure formulas never break or lose meaning in the adapted formats and in the chat assistant.",
    faq4Q: 'Can I use Plynote to prepare my tutoring lessons ?',
    faq4A: "Absolutely. Plynote automatically generates mindmaps, flashcards, audio summaries, and adapts to each student's memory.",
    faq5Q: 'Are my documents secure? What happens to my data ?',
    faq5A: 'Your documents are securely stored. We never use your data to train our AI models. You can delete all your documents at any time.',
    faq6Q: 'Can I use Plynote for confidential client documents ?',
    faq6A: 'Yes. Plynote respects your confidentiality. No document is shared with third parties or used for any purpose other than your personal use.',
    faq7Q: 'Can I cancel anytime ?',
    faq7A: 'Yes. You can cancel your subscription anytime from your dashboard with no cancellation fees.',
    faq8Q: 'Is there a free trial ?',
    faq8A: 'Yes, and no credit card required.',
    footerProduct: 'Product',
    footerLegal: 'Legal',
    footerComparative: 'Comparative',
    footerFeatures: 'Features',
    footerHelp: 'Help',
    footerPrivacy: 'Privacy Policy',
    footerTerms: 'Terms of Service',
    footerSupport: 'Support',
  },
};

export default en;
